import styled from 'styled-components';
import {
  accentColorPrim,
  accentColorSecond,
  accentColorTertiary, black,
  bpMd,
  bpSm,
  bpXl,
  bpXxl,
  fontColorPrim,
  fontColorSecond,
  white,
} from './vars';
import * as CSS from 'csstype';
import { Grid } from '@progress/kendo-react-grid';
import {transparentize} from 'polished'

interface ContainerProps {}

export const Container = styled.div<Partial<CSS.Properties & ContainerProps>>`
  width: 100%;
  height: 100%;
  flex-grow: 1;
  max-width: ${(props) => props.maxWidth || '100%'};
  display: flex;
  flex-wrap: wrap;
  align-items: ${(props) => props.alignItems};
  justify-content: center;
  padding: ${(props) => props.padding || '0 1.5rem'};
`;

interface RowProps {}

export const Row = styled.div<Partial<CSS.Properties & RowProps>>`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  margin: ${(props) => props.padding || '0 -1.5rem'};
`;

interface ColumnProps {
  xs: any;
  flexCol: any;
  flexRow: any;
  sm: any;
  md: any;
  lg: any;
  xl: any;
  stretch: boolean;
}

export const Column = styled.div<Partial<CSS.Properties & ColumnProps>>`
  padding: ${(props) => props.padding || '0 1.5rem'};
  max-width: ${(props) =>
    props.xs !== 'hidden' && props.xs ? props.xs + '%' : '100%'};
  flex: 0 0
    ${(props) => (props.xs !== 'hidden' && props.xs ? props.xs + '%' : '100%')};
  ${(props) => props.flexCol && 'display:flex;flex-direction:column;'}
  ${(props) =>
    props.flexRow && 'display:flex;flex-wrap:wrap; align-items:center'}
  ${(props) => props.stretch && 'height:100%;'}
  @media(max-width:767px) {
    ${(props) => props.xs === 'hidden' && 'display:none'};
  }
  @media (min-width: ${bpSm}) {
    max-width: ${(props) =>
      props.sm !== 'hidden' && props.sm
        ? props.sm + '%'
        : props.xs !== 'hidden' && props.xs
        ? props.xs + '%'
        : '100%'};
    flex: 0 0
      ${(props) =>
        props.sm !== 'hidden' && props.sm
          ? props.sm + '%'
          : props.xs !== 'hidden' && props.xs
          ? props.xs + '%'
          : '100%'};
  }
  @media (min-width: ${bpSm}) and (max-width: 990px) {
    ${(props) => props.sm === 'hidden' && 'display:none'};
  }
  @media (min-width: ${bpMd}) {
    max-width: ${(props) =>
      props.md !== 'hidden' && props.md
        ? props.md + '%'
        : props.sm !== 'hidden' && props.sm
        ? props.sm + '%'
        : props.xs !== 'hidden' && props.xs
        ? props.xs + '%'
        : '100%'};
    flex: 0 0
      ${(props) =>
        props.md !== 'hidden' && props.md
          ? props.md + '%'
          : props.sm !== 'hidden' && props.sm
          ? props.sm + '%'
          : props.xs !== 'hidden' && props.xs
          ? props.xs + '%'
          : '100%'};
  }
  @media (min-width: ${bpMd}) and (max-width: 1279px) {
    ${(props) => props.md === 'hidden' && 'display:none'};
  }
  @media (min-width: ${bpXl}) {
    max-width: ${(props) =>
      props.lg !== 'hidden' && props.lg
        ? props.lg + '%'
        : props.md !== 'hidden' && props.md
        ? props.md + '%'
        : props.sm !== 'hidden' && props.sm
        ? props.sm + '%'
        : props.xs !== 'hidden' && props.xs
        ? props.xs + '%'
        : '100%'};
    flex: 0 0
      ${(props) =>
        props.lg !== 'hidden' && props.lg
          ? props.lg + '%'
          : props.md !== 'hidden' && props.md
          ? props.md + '%'
          : props.sm !== 'hidden' && props.sm
          ? props.sm + '%'
          : props.xs !== 'hidden' && props.xs
          ? props.xs + '%'
          : '100%'};
    ${(props) => props.lg === 'hidden' && 'display:none'};
  }
  @media (min-width: ${bpXxl}) {
    max-width: ${(props) =>
      props.xl !== 'hidden' && props.xl
        ? props.xl + '%'
        : props.lg !== 'hidden' && props.lg
        ? props.lg + '%'
        : props.md !== 'hidden' && props.md
        ? props.md + '%'
        : props.sm !== 'hidden' && props.sm
        ? props.sm + '%'
        : props.xs !== 'hidden' && props.xs
        ? props.xs + '%'
        : '100%'};
    flex: 0 0
      ${(props) =>
        props.xl !== 'hidden' && props.xl
          ? props.xl + '%'
          : props.lg !== 'hidden' && props.lg
          ? props.lg + '%'
          : props.md !== 'hidden' && props.md
          ? props.md + '%'
          : props.sm !== 'hidden' && props.sm
          ? props.sm + '%'
          : props.xs !== 'hidden' && props.xs
          ? props.xs + '%'
          : '100%'};
    ${(props) => props.xl === 'hidden' && 'display:none'};
  }
`;

interface WrapProps {
  flexDir: any;
  alignItems: any;
  justifyCont: any;
  fs: string;
  fw: string;
  bgColor: string;
  br: string;
  grow: string;
  width: any;
  sidebar: boolean;
  rightSide: boolean;
  borders: any;
  overflow: any;
  inlineBlock: boolean;
  textLeft: boolean;
  visible: boolean;
  hiddenSM: boolean;
  hiddenXS: boolean;
  color: any;
  maxWidth: any;
  padding: any;
  margin: any;
  bs: any;
  flexWrap: any;
}

export const Wrap = styled.div<Partial<CSS.Properties & WrapProps>>`
  line-height: 1.4;
  padding: ${(props) =>
    props.padding
      ? typeof props.padding !== 'string'
        ? props.padding[0]
        : props.padding
      : '0'};
  margin: ${(props) =>
    props.margin
      ? typeof props.margin !== 'string'
        ? props.margin[0]
        : props.margin
      : '0'};
  width: ${(props) => props.width ? (typeof props.width !== 'string' ? props.width[0] : props.width) : 'auto'};
  height: ${(props) => props.height || 'auto'};
  max-width: ${(props) => props.maxWidth ? (typeof props.maxWidth !== 'string' ? props.maxWidth[0] : props.maxWidth) : '100%'};
  max-height: ${(props) => props.maxHeight || 'none'};
  min-height: ${(props) => props.minHeight || 'auto'};
  display: flex;
  flex-direction: ${(props) => props.flexDir ? (typeof props.flexDir !== 'string' ? props.flexDir[0] : props.flexDir) : 'row'};
  flex-wrap: ${(props) =>
  props.flexWrap ?
    ((typeof props.flexWrap === 'string' && props.flexWrap === 'row-reverse') || 
     (typeof props.flexWrap === 'string' && props.flexWrap === 'row') ||
     (typeof props.flexWrap !== 'string' && props.flexWrap[0] === 'row-reverse') ||
     (typeof props.flexWrap !== 'string' && props.flexWrap[0] === 'row') ? 'wrap' : 'nowrap')
  : (props.flexDir ?
    ((typeof props.flexDir === 'string' && props.flexDir === 'column') ||
     (typeof props.flexDir !== 'string' && props.flexDir[0] === 'column') ? 'nowrap' : 'wrap')
    : 'wrap')};
  align-items: ${(props) => props.alignItems ? (typeof props.alignItems !== 'string' ? props.alignItems[0] : props.alignItems) : 'flex-start'};
  justify-content: ${(props) => props.justifyCont ? (typeof props.justifyCont !== 'string' ? props.justifyCont[0] : props.justifyCont) : 'flex-start'};
  font-size: ${(props) => props.fs || '1.6rem'};
  font-weight: ${(props) => props.fw || '400'};
  box-shadow: ${(props)=> props.bs || 'none'};
  color: ${(props: any) =>
    props.color
      ? typeof props.color !== 'string'
        ? props.color[0]
        : props.color
      : fontColorPrim};
  background-color: ${(props) =>
    props.bgColor
      ? typeof props.bgColor !== 'string'
        ? props.bgColor[0]
        : props.bgColor
      : 'transparent'};
  flex-grow: ${(props) => props.grow || '0'};
  border-radius: ${(props) => props.br || '0'};
  overflow-y: ${(props) => props.overflow ? (typeof props.overflow !== 'string' ? props.overflow[0] : props.overflow) : 'unset'};
  ${(props) => (props.overflow && !props.overflowX ? 'overflow-x:hidden' : '')};
  ${(props) => props.overflowX ? 'overflow-x: auto' : ''};
  ${(props) =>
    props.borders
      ? typeof props.borders !== 'string'
        ? (props.borders.length > 1
          ? props.borders[0].map(
              (item: any) => `border-${item.side}: 1px solid ${item.color || accentColorTertiary};`,
            )
          :
          props.borders.map(
            (item: any) => `border-${item.side}: 1px solid ${item.color || accentColorTertiary};`,
          ))
        : `border: 1px solid ${props.borders || accentColorTertiary};`
      : 'border: 0;'}
      
  @media(min-width:${bpXl}){
    width: ${(props) => props.width ? (typeof props.width !== 'string' ? props.width[1] : props.width) : 'auto'};
    min-height: ${(props) => props.minHeight || 'auto'};
    color: ${(props:any) => props.color ? (typeof props.color !== 'string' ? props.color[1] : props.color) : fontColorPrim};
    max-width: ${(props) => props.maxWidth ? (typeof props.maxWidth !== 'string' ? props.maxWidth[1] : props.maxWidth) : '100%'};
    padding: ${(props:any) => props.padding ? (typeof props.padding !== 'string' ? props.padding[1] : props.padding) : '0'};
    margin: ${(props:any) => props.margin ? (typeof props.margin !== 'string' ? props.margin[1] : props.margin) : '0'};
    background-color: ${(props) => props.bgColor ? (typeof props.bgColor !== 'string' ? props.bgColor[1] : props.bgColor) : 'transparent'};
    flex-direction: ${(props) => props.flexDir ? (typeof props.flexDir !== 'string' ? props.flexDir[1] : props.flexDir) : 'row'};
    flex-wrap: ${(props) =>
  props.flexWrap ?
    ((typeof props.flexWrap === 'string' && props.flexWrap === 'row-reverse') ||
    (typeof props.flexWrap === 'string' && props.flexWrap === 'row') ||
    (typeof props.flexWrap !== 'string' && props.flexWrap[1] === 'row-reverse') ||
    (typeof props.flexWrap !== 'string' && props.flexWrap[1] === 'row') ? 'wrap' : 'nowrap')
    : (props.flexDir ?
    ((typeof props.flexDir === 'string' && props.flexDir === 'column') ||
    (typeof props.flexDir !== 'string' && props.flexDir[1] === 'column') ? 'nowrap' : 'wrap')
    : 'wrap')};
    align-items: ${(props) => props.alignItems ? (typeof props.alignItems !== 'string' ? props.alignItems[1] : props.alignItems) : 'flex-start'};
    justify-content: ${(props) => props.justifyCont ? (typeof props.justifyCont !== 'string' ? props.justifyCont[1] : props.justifyCont) : 'flex-start'};
    overflow-y: ${(props) => props.overflow ? (typeof props.overflow !== 'string' ? props.overflow[0] : props.overflow) : 'unset'};
    ${(props) =>
      props.borders
        ? typeof props.borders !== 'string'
          ? (props.borders.length > 1
        ? props.borders[1].map(
            (item: any) => `border-${item.side}: 1px solid ${item.color || accentColorTertiary};`,)
        : props.borders.map(
            (item: any) => `border-${item.side}: 1px solid ${item.color || accentColorTertiary};`,))
          : `border: 1px solid ${props.borders || accentColorTertiary};` 
        : 'border: 0;'}
  }
  ${(props) => props.flexDir === 'column' && 'flex-wrap: nowrap;'}
  ${(props) => props.inlineBlock && 'display: inline-block;'}
  ${(props) => props.textLeft && 'text-align: left;'}
    ${(props) =>
    props.hiddenSM &&
    `@media(min-width:${bpXl}){display:none;}`}
    ${(props) =>
    props.hiddenXS &&
    `@media(max-width: 1279px){display:none}`}`;

export const StyledTable = styled(Grid)`
  overflow-x:auto;
  height:100%!important;
  table{width:100%!important;}
  &,
  .k-grid-header {
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid ${accentColorSecond};
  }
  .k-header,
  th.k-header {
    border: 0;
    padding: 1.6rem 1rem;
    font-size: 1.4rem;
    color: ${fontColorSecond};
  }
  & td {
    font-size: 1.6rem;
    color: #7E838D;
    padding: 1.6rem 1rem;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    border-bottom: 1px solid ${accentColorSecond};
  }
  tr.k-alt,
  .k-grid-content,
  tr.k-grouping-row,
  tr .k-group-cell,
  tr.k-grouping-row td{
    background-color: transparent;
  }
  tbody tr {
    transition: 0.2s;
    cursor: pointer;
    &.k-state-selected td{
      background-color: ${transparentize(.75, accentColorPrim)};
    }
    &:hover {
      background-color: ${white};
      td{
        color:${black};
        .badge{
          background-color: ${accentColorPrim};
          color:${white};
        }
      }
      button {
        opacity: 1;

        &[disabled] {
          opacity: 0.4;
          cursor: not-allowed;
        }
      }
    }
  }
`;
